module.exports = __webpack_public_path__ + "static/media/sunrise.09d03aad.png";